const theme = {
  global: {
    colors: {
      brand: '#000000',
      black: '#000000',
      focus: '#FEC325',
      text: '#444444',
      white: '#FFFFFF',
      'accent-1': '#f5c24c',
      'accent-2': '#DDDDDD',
      'accent-3': '#DDD0A1',
      'accent-4': '#C9B469',
      'accent-5': '#f7f7f7',
      'neutral-1': '#CA3C45',
      'neutral-2': '#0554A3',
      'neutral-3': '#333333',
      'neutral-4': '#262826',
      'status-critical': '#EB6060',
      'status-error': '#EB6060',
      'status-warning': '#F7E463',
      'status-ok': '#7CD992',
      'status-info': '#0554A3',
      'status-unknown': '#a8a8a8',
      'status-disabled': '#a8a8a8',
      'status-halt': '#f2e36c',
      'dark-1': '#333333',
      'dark-2': '#444444',
      'dark-3': '#555555',
      'dark-4': '#666666',
      'dark-5': '#777777',
      'dark-6': '#999999',
      'light-1': '#F6F6F6',
      'light-2': '#EEEEEE',
      'light-3': '#DDDDDD',
      'light-4': '#CCCCCC',
      'light-5': '#BBBBBB',
      'light-6': '#AAAAAA',
    },
  },
  anchor: {
    color: {
      dark: '#0554A3',
      light: '#0554A3',
    },
  },
  button: {
    border: {
      radius: '0px',
    },
  },
  icon: {
    colors: {
      brand: '#000000',
      black: '#000000',
      focus: '#FEC325',
      text: '#444444',
      white: '#FFFFFF',
      'accent-1': '#f5c24c',
      'accent-2': '#E9E4D3',
      'accent-3': '#DDD0A1',
      'accent-4': '#C9B469',
      'neutral-1': '#CA3C45',
      'neutral-2': '#0554A3',
      'neutral-3': '#696B5D',
      'neutral-4': '#262826',
      'status-critical': '#EB6060',
      'status-error': '#EB6060',
      'status-warning': '#F7E463',
      'status-ok': '#7CD992',
      'status-info': '#0554A3',
      'status-unknown': '#a8a8a8',
      'status-disabled': '#a8a8a8',
    },
  },
  paragraph: {
    small: {
      size: '14px',
      height: '20px',
      maxWidth: '336px',
    },
    medium: {
      size: '18px',
      height: '24px',
      maxWidth: '600px',
    },
    large: {
      size: '22px',
      height: '28px',
      maxWidth: '600px',
    },
    xlarge: {
      size: '26px',
      height: '32px',
      maxWidth: '600px',
    },
  },
};

/*
const base = {
  global: {
    animation: {
      duration: '1s',
      jiggle: {
        duration: '0.1s'
      }
    },
    borderSize: {
      xsmall: '1px',
      small: '2px',
      medium: '4px',
      large: '12px',
      xlarge: '24px',
      narrow: {
        xsmall: '1px',
        small: '2px',
        medium: '4px',
        large: '6px',
        xlarge: '12px'
      }
    },
    breakpoints: {
      narrow: 699
    },
    colors: {
      active: 'rgba(221,221,221,0.5)',
      black: '#000000',
      border: 'rgba(0, 0, 0, 0.33)',
      'border-light': 'rgba(0, 0, 0, 0.33)',
      'border-dark': 'rgba(255, 255, 255, 0.33)',
      brand: '#7D4CDB',
      focus: '#FD6FFF',
      placeholder: '#AAAAAA',
      text: '#444444',
      white: '#FFFFFF',
      'accent-1': '#FD6FFF',
      'accent-2': '#61EC9F',
      'accent-3': '#60EBE1',
      'accent-4': '#FFCA58',
      'dark-1': '#333333',
      'dark-2': '#444444',
      'dark-3': '#555555',
      'dark-4': '#666666',
      'dark-5': '#777777',
      'dark-6': '#999999',
      'light-1': '#F6F6F6',
      'light-2': '#EEEEEE',
      'light-3': '#DDDDDD',
      'light-4': '#CCCCCC',
      'light-5': '#BBBBBB',
      'light-6': '#AAAAAA',
      'neutral-1': '#3D138D',
      'neutral-2': '#BE60EB',
      'neutral-3': '#00C781',
      'neutral-4': '#6194EB',
      'neutral-5': '#FFB202',
      'status-critical': '#EB6060',
      'status-error': '#EB6060',
      'status-warning': '#F7E463',
      'status-ok': '#7CD992',
      'status-unknown': '#a8a8a8',
      'status-disabled': '#a8a8a8'
    },
    control: {
      border: {
        width: '2px',
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        }
      },
      color: {
        dark: [
          null
        ],
        light: [
          null
        ]
      }
    },
    drop: {
      background: '#ffffff',
      border: {
        width: '0px',
        radius: '0px'
      },
      shadow: {
        light: '0px 3px 8px rgba(100, 100, 100, 0.50)',
        dark: '0px 3px 8px rgba(255, 255, 255, 0.40)'
      }
    },
    edgeSize: {
      none: '0',
      hair: '1px',
      xxsmall: '3px',
      xsmall: '6px',
      small: '12px',
      medium: '24px',
      large: '48px',
      xlarge: '96px',
      narrow: {
        none: '0',
        hair: '1px',
        xxsmall: '2px',
        xsmall: '3px',
        small: '6px',
        medium: '12px',
        large: '24px',
        xlarge: '48px'
      }
    },
    elevation: {
      light: {
        none: 'none',
        xsmall: '0px 1px 2px rgba(100, 100, 100, 0.50)',
        small: '0px 2px 4px rgba(100, 100, 100, 0.50)',
        medium: '0px 3px 8px rgba(100, 100, 100, 0.50)',
        large: '0px 6px 12px rgba(100, 100, 100, 0.50)',
        xlarge: '0px 8px 16px rgba(100, 100, 100, 0.50)'
      },
      dark: {
        none: 'none',
        xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
        small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
        medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
        large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
        xlarge: '0px 10px 24px rgba(255, 255, 255, 0.40)'
      }
    },
    focus: {
      border: {
        color: [
          null
        ],
        width: '2px'
      }
    },
    font: {
      size: '18px',
      height: '24px',
      maxWidth: '432px'
    },
    hover: {
      background: {
        dark: {
          color: 'active',
          opacity: 'medium'
        },
        light: {
          color: 'active',
          opacity: 'medium'
        }
      },
      color: {
        dark: 'white',
        light: 'black'
      }
    },
    input: {
      border: {
        width: '1px',
        radius: '4px'
      },
      weight: 600
    },
    opacity: {
      strong: '0.8',
      medium: '0.4',
      weak: '0.1'
    },
    spacing: '24px',
    size: {
      xxsmall: '48px',
      xsmall: '96px',
      small: '192px',
      medium: '384px',
      large: '768px',
      xlarge: '1152px',
      full: '100%',
      narrow: {
        xxsmall: '24px',
        xsmall: '48px',
        small: '96px',
        medium: '192px',
        large: '384px',
        xlarge: '768px',
        full: '100%'
      }
    },
    text: {
      color: {
        dark: '#f8f8f8',
        light: '#444444'
      }
    }
  },
  accordion: {
    icons: {}
  },
  anchor: {
    textDecoration: 'none',
    fontWeight: 600,
    color: {
      dark: '#6194EB',
      light: '#6194EB'
    }
  },
  button: {
    border: {
      width: '2px',
      radius: '18px'
    },
    primary: {
      color: {
        dark: [
          null
        ],
        light: [
          null
        ]
      }
    },
    disabled: {
      opacity: 0.3
    },
    minWidth: '96px',
    maxWidth: '384px',
    padding: {
      vertical: '4px',
      horizontal: '22px'
    }
  },
  calendar: {
    small: {
      fontSize: '14px',
      lineHeight: 1.375,
      daySize: '27.428571428571427px',
      slideDuration: '0.2s'
    },
    medium: {
      fontSize: '18px',
      lineHeight: 1.45,
      daySize: '54.857142857142854px',
      slideDuration: '0.5s'
    },
    large: {
      fontSize: '22px',
      lineHeight: 1.11,
      daySize: '109.71428571428571px',
      slideDuration: '0.8s'
    },
    icons: {
      small: {}
    }
  },
  carousel: {
    icons: {}
  },
  checkBox: {
    border: {
      color: {
        dark: 'rgba(255, 255, 255, 0.5)',
        light: 'rgba(0, 0, 0, 0.15)'
      },
      radius: '4px',
      width: '2px'
    },
    check: {
      width: '4px'
    },
    icons: {},
    hover: {
      border: {
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        }
      }
    },
    size: '24px',
    toggle: {
      color: {
        dark: '#d9d9d9',
        light: '#d9d9d9'
      },
      radius: '24px',
      size: '48px'
    }
  },
  clock: {
    analog: {
      hour: {
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        },
        width: '8px',
        size: '24px',
        shape: 'round'
      },
      minute: {
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        },
        width: '4px',
        size: '12px',
        shape: 'round'
      },
      second: {
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        },
        width: '3px',
        size: '9px',
        shape: 'round'
      },
      size: {
        small: '72px',
        medium: '96px',
        large: '144px',
        xlarge: '216px',
        huge: '288px'
      }
    },
    digital: {
      text: {
        xsmall: {
          size: '10px',
          height: 1.5
        },
        small: {
          size: '14px',
          height: 1.43
        },
        medium: {
          size: '18px',
          height: 1.375
        },
        large: {
          size: '22px',
          height: 1.167
        },
        xlarge: {
          size: '26px',
          height: 1.1875
        },
        xxlarge: {
          size: '34px',
          height: 1.125
        }
      }
    }
  },
  collapsible: {
    minSpeed: 150,
    baseHeight: 500
  },
  dataTable: {
    body: {
      pad: {
        horizontal: 'small',
        vertical: 'xsmall'
      }
    },
    footer: {
      border: {
        side: 'top',
        size: 'small'
      },
      pad: {
        horizontal: 'small',
        vertical: 'xsmall'
      }
    },
    groupHeader: {
      border: {
        side: 'bottom',
        size: 'xsmall'
      },
      pad: {
        horizontal: 'small',
        vertical: 'xsmall'
      },
      background: {
        dark: 'dark-2',
        light: 'light-2'
      }
    },
    header: {
      border: {
        side: 'bottom',
        size: 'small'
      },
      pad: {
        horizontal: 'small',
        vertical: 'xsmall'
      },
      background: {
        dark: 'dark-1',
        light: 'light-1'
      }
    },
    icons: {},
    resize: {
      border: {
        side: 'right',
        color: {
          dark: 'border-dark',
          light: 'border-light'
        }
      }
    }
  },
  formField: {
    border: {
      color: {
        dark: 'border-dark',
        light: 'border-light'
      },
      position: 'inner',
      side: 'bottom',
      error: {
        color: {
          dark: 'white',
          light: 'status-critical'
        }
      }
    },
    error: {
      color: {
        dark: 'status-critical',
        light: 'status-critical'
      }
    },
    help: {
      color: {
        dark: 'dark-5',
        light: 'dark-5'
      }
    },
    label: {}
  },
  grommet: {},
  heading: {
    font: {},
    level: {
      '1': {
        small: {
          size: '34px',
          height: '40px',
          maxWidth: '816px'
        },
        medium: {
          size: '50px',
          height: '56px',
          maxWidth: '1200px'
        },
        large: {
          size: '82px',
          height: '88px',
          maxWidth: '1968px'
        }
      },
      '2': {
        small: {
          size: '26px',
          height: '32px',
          maxWidth: '624px'
        },
        medium: {
          size: '34px',
          height: '40px',
          maxWidth: '816px'
        },
        large: {
          size: '50px',
          height: '56px',
          maxWidth: '1200px'
        }
      },
      '3': {
        small: {
          size: '22px',
          height: '28px',
          maxWidth: '528px'
        },
        medium: {
          size: '22px',
          height: '28px',
          maxWidth: '528px'
        },
        large: {
          size: '34px',
          height: '40px',
          maxWidth: '816px'
        }
      },
      '4': {
        small: {
          size: '18px',
          height: '24px',
          maxWidth: '432px'
        },
        medium: {
          size: '18px',
          height: '24px',
          maxWidth: '432px'
        },
        large: {
          size: '18px',
          height: '24px',
          maxWidth: '432px'
        }
      }
    },
    weight: 600
  },
  icon: {
    colors: {
      active: 'rgba(221,221,221,0.5)',
      black: '#000000',
      border: 'rgba(0, 0, 0, 0.33)',
      'border-light': 'rgba(0, 0, 0, 0.33)',
      'border-dark': 'rgba(255, 255, 255, 0.33)',
      brand: '#7D4CDB',
      focus: '#FD6FFF',
      placeholder: '#AAAAAA',
      text: '#444444',
      white: '#FFFFFF',
      'accent-1': '#FD6FFF',
      'accent-2': '#61EC9F',
      'accent-3': '#60EBE1',
      'accent-4': '#FFCA58',
      'dark-1': '#333333',
      'dark-2': '#444444',
      'dark-3': '#555555',
      'dark-4': '#666666',
      'dark-5': '#777777',
      'dark-6': '#999999',
      'light-1': '#F6F6F6',
      'light-2': '#EEEEEE',
      'light-3': '#DDDDDD',
      'light-4': '#CCCCCC',
      'light-5': '#BBBBBB',
      'light-6': '#AAAAAA',
      'neutral-1': '#3D138D',
      'neutral-2': '#BE60EB',
      'neutral-3': '#00C781',
      'neutral-4': '#6194EB',
      'neutral-5': '#FFB202',
      'status-critical': '#EB6060',
      'status-error': '#EB6060',
      'status-warning': '#F7E463',
      'status-ok': '#7CD992',
      'status-unknown': '#a8a8a8',
      'status-disabled': '#a8a8a8'
    }
  },
  iconThemes: {},
  layer: {
    background: 'white',
    border: {
      radius: '4px'
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.5)'
    }
  },
  menu: {
    icons: {}
  },
  paragraph: {
    small: {
      size: '14px',
      height: '20px',
      maxWidth: '336px'
    },
    medium: {
      size: '18px',
      height: '24px',
      maxWidth: '432px'
    },
    large: {
      size: '22px',
      height: '28px',
      maxWidth: '528px'
    },
    xlarge: {
      size: '26px',
      height: '32px',
      maxWidth: '624px'
    }
  },
  radioButton: {
    check: {},
    border: {
      color: {
        dark: 'rgba(255, 255, 255, 0.5)',
        light: 'rgba(0, 0, 0, 0.15)'
      },
      radius: '100%',
      width: '2px'
    },
    size: '24px'
  },
  rangeInput: {
    track: {
      height: '4px',
      color: {
        dark: [
          null
        ],
        light: [
          null
        ]
      }
    },
    thumb: {}
  },
  select: {
    icons: {},
    step: 20
  },
  text: {
    xsmall: {
      size: '12px',
      height: '18px',
      maxWidth: '288px'
    },
    small: {
      size: '14px',
      height: '20px',
      maxWidth: '336px'
    },
    medium: {
      size: '18px',
      height: '24px',
      maxWidth: '432px'
    },
    large: {
      size: '22px',
      height: '28px',
      maxWidth: '528px'
    },
    xlarge: {
      size: '26px',
      height: '32px',
      maxWidth: '624px'
    },
    xxlarge: {
      size: '34px',
      height: '40px',
      maxWidth: '816px'
    }
  },
  video: {
    captions: {
      background: 'rgba(0,0,0,0.7)'
    },
    icons: {}
  },
  worldMap: {
    continent: {
      active: '8px',
      base: '6px'
    },
    place: {
      active: '20px',
      base: '8px'
    }
  }
}
*/

export default theme;



// WEBPACK FOOTER //
// ./src/app/style/theme.js